import { NgModule, Injectable } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatBadgeModule } from '@angular/material/badge';
import { InfiniteScrollModule } from "ngx-infinite-scroll";


// import { CheckboxModule } from 'primeng/checkbox';
// import { AutoCompleteModule } from 'primeng/autocomplete';
// import { DragDropModule } from 'primeng/dragdrop';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { PopoverModule } from 'ngx-bootstrap/popover';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';


import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { DropdownModule } from 'primeng/dropdown';

import { DragulaModule, DragulaService, DragulaDirective } from 'ng2-dragula';
import { ColorPickerModule } from 'ngx-color-picker';
import { MatMenuModule } from '@angular/material/menu';

import { NgbTabComponent } from '../commons/ngb-tabset/ngb-tab.component';
import { NgbTabsetComponent } from '../commons/ngb-tabset/ngb-tabset.component';

import { NgbTabTitleDirective, NgbTabContentDirective } from '../commons/ngb-tabset/ngb-tab.directive';

import { FicheClientComponent, MaskInputPipe } from '../commons/fiche-client/fiche-client.component';
import { GeneralComponent } from '../commons/fiche-client/general/general.component';
import { FichecltContactComponent } from '../commons/fiche-client/general/ficheclt-contact/ficheclt-contact.component';
import { UserEcoPortailComponent } from '../commons/fiche-client/general/user-eco-portail/user-eco-portail.component';
import { DocumentClientComponent } from '../commons/fiche-client/general/document-client/document-client.component';
import { EntrepriseTravauxComponent } from '../commons/fiche-client/general/entreprise-travaux/entreprise-travaux.component';
import { GestionFipComponent } from '../commons/fiche-client/general/gestion-fip/gestion-fip.component';
import { ComptaComponent } from '../commons/fiche-client/compta/compta.component';
import { FactComponent } from '../commons/fiche-client/fact/fact.component';
import { IbanBicComponent } from '../commons/fiche-client/compta/iban-bic/iban-bic.component';
import { TropPercusComponent } from '../commons/fiche-client/compta/trop-percus/trop-percus.component';
import { MontantsTeomComponent } from '../commons/fiche-client/compta/montants-teom/montants-teom.component';
import { CommerceComponent } from '../commons/fiche-client/commerce/commerce.component';
import { FactAutoComponent } from '../commons/fiche-client/fact-auto/fact-auto.component';
import { PrixNegociesComponent } from '../commons/fiche-client/commerce/prix-negocies/prix-negocies.component';
import { NomenclatureNegoComponent } from '../commons/fiche-client/commerce/nomenclature-nego/nomenclature-nego.component';
import { LibelleNegoComponent } from '../commons/fiche-client/commerce/libelle-nego/libelle-nego.component';
import { CapClientComponent } from '../commons/fiche-client/commerce/cap-client/cap-client.component';
import { ListeCapComponent } from '../commons/fiche-client/commerce/liste-cap/liste-cap.component';
import { LimiterExutoireComponent } from '../commons/fiche-client/commerce/limiter-exutoire/limiter-exutoire.component';
import { EmptyDetailFactComponent } from '../ecofact/gestion-facture/empty-detail-fact/empty-detail-fact.component';
import { SoldeComponent } from '../commons/fiche-client/solde/solde.component';
import { InfoPartComponent } from '../commons/fiche-client/info-part/info-part.component';
import { CompeCollTvaComponent } from '../commons/fiche-client/compta/compe-coll-tva/compe-coll-tva.component';

import { MatTabsModule } from '@angular/material/tabs';
import {
  OnReturnDirective, OnlyNumberDirective, OnMaskInputDirective,
  SelectValueDirective, DisableAutoCompleteDirective,
} from '../commons/directives/keydown.directive';
import { DebounceClickDirective } from '../commons/directives/debounce-click.directive';
import { HighlightPipe } from '../commons/autocomplete/autocomplete.component';
import { AlertComponent } from '../commons/alert-message/alert.component';
import { AutocompleteComponent } from '../commons/autocomplete/autocomplete.component';
import { AutocompleteMaterialComponent } from '../commons/autocomplete-material/autocomplete-material.component';

import { PanneauLogoComponent } from '../commons/panneau-logo/panneau-logo.component';
import { RechercheMultipleComponent } from '../commons/recherche-multiple/recherche-multiple.component';
import { EmptyTableComponent } from '../ecoloc/validation-bons/empty-table/empty-table.component';
import { AutocompleteCpVilleComponent } from '../commons/autocomplete-cp-ville/autocomplete-cp-ville.component';
import { FilterTailleComponent } from '../commons/filter-taille/filter-taille.component';
import { LogComponent } from '../commons/log-prestation/log.component';
import { PanneauMailComponent } from '../commons/panneau-mail/panneau-mail.component';
import { GestionDocumentComponent } from '../commons/gestion-document/gestion-document.component';

import { FicheChantierComponent } from '../commons/fiche-chantier/fiche-chantier.component';
import { InfoGeneralComponent } from '../commons/fiche-chantier/info-general/info-general.component';
import { InfoSuppComponent } from '../commons/fiche-chantier/info-supp/info-supp.component';
import { InfoFactComponent } from '../commons/fiche-chantier/info-fact/info-fact.component';
import { DocComponent } from '../commons/fiche-chantier/doc/doc.component';
import { AmianteComponent } from '../commons/fiche-chantier/amiante/amiante.component';
import { InfoDetenteurComponent } from '../commons/fiche-chantier/info-detenteur/info-detenteur.component';

import { DragulaExtendedDirective } from '../commons/directives/dragula-extended.directive';
import { FicheContactComponent } from '../commons/fiche-contact/fiche-contact.component';
import { InputDateComponent } from '../commons/input-date/input-date.component';

import { SelectPeriodeComponent } from '../commons/select-periode/select-periode.component';
import { FicheAgenceComponent } from '../commons/fiche-agence/fiche-agence.component';
import { environment } from '../../environments/environment';

import { SafePipe } from '../ecoloc/validation-bons/messages-bon/messages-bon.component';

import { SvgBenneComponent } from '../ecobennes/mvt-bennes/svg-benne/svg-benne.component';
import { SvgBacComponent } from '../ecobennes/mvt-bennes/svg-bac/svg-bac.component';
import { SvgCaissepaletteComponent } from '../ecobennes/mvt-bennes/svg-caissepalette/svg-caissepalette.component';
import { SvgTasComponent } from '../ecobennes/mvt-bennes/svg-tas/svg-tas.component';
import { SvgFutComponent } from '../ecobennes/mvt-bennes/svg-fut/svg-fut.component';
import { SvgBigbagComponent } from '../ecobennes/mvt-bennes/svg-bigbag/svg-bigbag.component';
import { SvgGroupeComponent } from '../ecobennes/mvt-bennes/svg-groupe/svg-groupe.component';
import { CreateMvtComponent } from '../ecobennes/mvt-bennes/create-mvt/create-mvt.component';
import { ContenantComponent } from '../ecobennes/mvt-bennes/contenant/contenant.component';
import { PgmJoursFeriesComponent } from '../ecobennes/mvt-bennes/create-mvt/pgm-jours-feries/pgm-jours-feries.component';
import { PgmSuspensionComponent } from '../ecobennes/mvt-bennes/create-mvt/pgm-suspension/pgm-suspension.component';
import { LocationFacturationComponent } from '../ecobennes/mvt-bennes/create-mvt/location-facturation/location-facturation.component';

import { AddContenantTourneesComponent } from '../ecobennes/tournees/add-contenant-tournees/add-contenant-tournees.component';

import { IconsEcoportailComponent } from '../ecoportail/icons-ecoportail/icons-ecoportail.component';
import { IconsDecheterieComponent } from '../ecoportail/icons-decheterie/icons-decheterie.component';

import { TarifQuantiteComponent } from '../commons/tarif-quantite/tarif-quantite.component';

import { ProgrammationsComponent } from '../commons/programmations/programmations.component';

// import { SortByPipe } from '../recylog/parametrage/parametrage.component';

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EditParamContenantComponent } from '../commons/edit-param-contenant/edit-param-contenant.component';

import { EditPersonnelComponent } from '../recylog/parametrage/logistique/personnel/edit-personnel/edit-personnel.component';
import { EditMaterielComponent } from '../recylog/parametrage/logistique/materiel/edit-materiel/edit-materiel.component';
import { EditTransporteurComponent } from '../recylog/parametrage/logistique/transporteurs/edit-transporteur/edit-transporteur.component';
import {
  TarifTransporteurComponent
} from '../recylog/parametrage/logistique/transporteurs/edit-transporteur/tarif-transporteur/tarif-transporteur.component';
import {
  TransporteurLogoComponent
} from '../recylog/parametrage/logistique/transporteurs/edit-transporteur/transporteur-logo/transporteur-logo.component';

import { DetailDevisComponent } from '../ecocrm/gestion-devis/detail-devis/detail-devis.component';
import { DetailDevisSuppComponent } from '../ecocrm/gestion-devis/detail-devis/detail-devis-supp/detail-devis-supp.component';
import { EmptyDetailDevisComponent } from '../ecocrm/gestion-devis/empty-detail-devis/empty-detail-devis.component';
import { DocumentRdvComponent } from '../ecocrm/document-rdv/document-rdv.component';
import { CreateMvtDevisComponent } from '../ecocrm/gestion-devis/detail-devis/create-mvt-devis/create-mvt-devis.component';
import { CreateDevisOpenIdComponent } from '../ecocrm/create-devis-open-id/create-devis-open-id.component';
import {
  PgmJoursFeriesDevisComponent
} from '../ecocrm/gestion-devis/detail-devis/create-mvt-devis/pgm-jours-feries-devis/pgm-jours-feries-devis.component';
import {
  PgmSuspensionDevisComponent
} from '../ecocrm/gestion-devis/detail-devis/create-mvt-devis/pgm-suspension-devis/pgm-suspension-devis.component';
import {
  LocationFacturationDevisComponent
} from '../ecocrm/gestion-devis/detail-devis/create-mvt-devis/location-facturation-devis/location-facturation-devis.component';
import {
  PlusMouvementComponent
} from '../ecocrm/gestion-devis/detail-devis/create-mvt-devis/plus-mouvement/plus-mouvement.component';


import { IconesEcoddComponent } from '../ecodd/icones-ecodd/icones-ecodd.component';

import { ChoixEquipesComponent } from '../commons/choix-equipes/choix-equipes.component';
import { SignaturePadComponent } from '../ecodechet/signature-pad/signature-pad.component';

import { MessagesBonComponent } from '../ecoloc/validation-bons/messages-bon/messages-bon.component';
import { CreatePrestationComponent } from '../ecoloc/planning-prestation/create-prestation/create-prestation.component';
import { DocumentBonEcolocComponent } from '../ecoloc/planning-prestation/document-bon-ecoloc/document-bon-ecoloc.component';
import { EquipeEcolocComponent } from '../ecoloc/planning-prestation/equipe-ecoloc/equipe-ecoloc.component';
import { PlusPrestComponent } from '../ecoloc/planning-prestation/create-prestation/plus-prest/plus-prest.component';
import { HistoPrestComponent } from '../ecoloc/planning-prestation/create-prestation/histo-prest/histo-prest.component';

import { StockBacComponent } from '../ecobac/stock-bac/stock-bac.component';
import { TooltipDirective } from '../commons/directives/tooltip.directive';

import { PScheduleComponent } from '../commons/p-schedule/p-schedule.component';

// import { CustomVirtualScrollDirective } from "./custom-virtual-scroll-strategy-directive";

@Pipe({
    name: 'safeStyle',
    standalone: false
})
export class SafeStylePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(value) {
    return this.sanitizer.bypassSecurityTrustStyle(value);
  }
}

import { Directive, ElementRef, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { AccessEcoportailComponent } from '../ecoportail/access-ecoportail/access-ecoportail.component';
import { MatSelectModule } from '@angular/material/select';
// import { ScrollingModule } from '@angular/cdk-experimental/scrolling';

@Directive({
    selector: '[clickOutside]',
    standalone: false
})
export class HighlightDirective {

  constructor(private _elementRef: ElementRef) { }

  @Output('clickOutside') clickOutside: EventEmitter<any> = new EventEmitter();

  @HostListener('document:click', ['$event.target']) onMouseEnter(targetElement) {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit(targetElement);
    }
  }


}


import * as _ from 'lodash';
import { CommonService } from '../commons/services/common.service';

@Pipe({
    name: 'sortBy',
    standalone: false
})
export class SortByPipe implements PipeTransform {

  transform(value: any[], column: string, order = ''): any[] {
    if (!value || !column || column === '' || order === '') {
      return value;
    } // no array
    if (value.length <= 1) {
      return value;
    } // array with only one item
    return _.orderBy(value, [column], [order && order === 'asc' ? 'asc' : 'desc']);
  }
}

@Pipe({
    name: 'callback',
    standalone: false
})
export class CallbackPipe implements PipeTransform {
  transform(items: any[], callback: (item: any) => boolean): any {
    if (!items || !callback) {
      return items;
    }
    return items.filter(item => callback(item));
  }
}

@Pipe({
    name: 'filterSearch',
    standalone: false
})
export class filterSearchPipe implements PipeTransform {

  transform(items: any[], field: string, value: string): any[] {

    if (!items) return [];
    if (!value) return items;


    return items.filter(str => {
      return str[field].toLowerCase().includes(value.toLowerCase());
    });
  }
}




@Directive({
    selector: '[routerLink]',
    standalone: false
})
export class RouterLinkTrackerDirective {
  constructor(private common: CommonService) { }

  @HostListener('click', ['$event'])
  onClick() {
    this.common.navigatedInternally = true;
  }
}


const addcomponent = !environment.isOpenId ? [CreateDevisOpenIdComponent] : [];

const componentInmportExport = [FicheClientComponent, GeneralComponent, ComptaComponent, FactComponent,
  CommerceComponent, HighlightPipe, AlertComponent, RechercheMultipleComponent, EmptyTableComponent, OnReturnDirective, OnlyNumberDirective,
  SelectValueDirective, DisableAutoCompleteDirective, AutocompleteComponent, AutocompleteMaterialComponent, AutocompleteCpVilleComponent,
  FilterTailleComponent, GestionDocumentComponent, LogComponent, PanneauMailComponent,
  DragulaExtendedDirective, FactAutoComponent, EmptyDetailFactComponent, FicheChantierComponent, InfoGeneralComponent,
  InfoSuppComponent, InfoFactComponent, DocComponent, AmianteComponent, InfoDetenteurComponent, FicheContactComponent,
  InputDateComponent, SelectPeriodeComponent, FicheAgenceComponent, SvgBenneComponent,
  SvgBacComponent,
  SvgCaissepaletteComponent,
  SvgTasComponent,
  SvgFutComponent,
  SvgBigbagComponent,
  SvgGroupeComponent,
  CreateMvtComponent,
  ContenantComponent,
  TarifQuantiteComponent,
  FichecltContactComponent,
  UserEcoPortailComponent,
  DocumentClientComponent,
  EntrepriseTravauxComponent,
  GestionFipComponent,
  IbanBicComponent,
  TropPercusComponent,
  MontantsTeomComponent,
  PrixNegociesComponent,
  NomenclatureNegoComponent,
  LibelleNegoComponent,
  CapClientComponent,
  ListeCapComponent,
  LimiterExutoireComponent,
  SortByPipe,
  IconsEcoportailComponent,
  IconsDecheterieComponent,
  SafeStylePipe,
  PgmJoursFeriesComponent,
  PgmSuspensionComponent,
  HighlightDirective,
  AddContenantTourneesComponent,
  SafePipe,
  CallbackPipe,
  filterSearchPipe,
  EditParamContenantComponent,
  PanneauLogoComponent,
  LocationFacturationComponent,
  EditPersonnelComponent,
  EditMaterielComponent,
  ProgrammationsComponent,
  SoldeComponent,
  InfoPartComponent,
  EditTransporteurComponent, TarifTransporteurComponent, TransporteurLogoComponent,
  DetailDevisComponent, DetailDevisSuppComponent, CreateMvtDevisComponent,
  PgmJoursFeriesDevisComponent, PgmSuspensionDevisComponent, LocationFacturationDevisComponent, DocumentRdvComponent,
  IconesEcoddComponent,
  EmptyDetailDevisComponent,
  ChoixEquipesComponent,
  MaskInputPipe,
  OnMaskInputDirective,
  CompeCollTvaComponent,
  SignaturePadComponent,
  PlusMouvementComponent,
  AccessEcoportailComponent,
  DebounceClickDirective,
  TooltipDirective,
  MessagesBonComponent, CreatePrestationComponent, DocumentBonEcolocComponent, EquipeEcolocComponent, PlusPrestComponent,
  HistoPrestComponent,
  StockBacComponent,
  RouterLinkTrackerDirective,
  NgbTabComponent,
  NgbTabsetComponent,
  NgbTabTitleDirective, NgbTabContentDirective, PScheduleComponent
];


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxDatatableModule,
    AlertModule.forRoot(),
    BsDropdownModule,
    PopoverModule.forRoot(),
    TypeaheadModule.forRoot(),
    // CheckboxModule,
    // AutoCompleteModule,
    // DragDropModule,
    NgbModule,
    DragulaModule.forRoot(),
    MatCheckboxModule,
    MatGridListModule,
    MatRadioModule,
    MatDividerModule,
    MatBadgeModule,
    ColorPickerModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatMenuModule,
    ScrollingModule,
    MatProgressBarModule,
    MatTabsModule,
    MatTableModule,
    InfiniteScrollModule,
    MatExpansionModule,
    DropdownModule
  ],
  exports: [MatCheckboxModule, MatBadgeModule, ScrollingModule, MatTableModule, MatInputModule, InfiniteScrollModule, DropdownModule, ...componentInmportExport, ...addcomponent],

  declarations: [...componentInmportExport, ...addcomponent],
  providers: [DragulaService]

})
export class ShardedModule { }
